import React, { useState } from 'react';
import { AI_AGENTS } from '../../../../utils/constants/ai-agents';
import Button from '../../../../shared/button';
import KnowledgeFilesModal from '../modals/KnowledgeFilesModal';

const AiAgents = () => {
    const [showFilesModal, setShowFilesModal] = useState<{ show: boolean, agent: any }>()

    const onClickFilesAgent = (agent: any) => {
        setShowFilesModal({
            show: true,
            agent: agent
        })
    }

    const onHideFilesModal = () => {
        setShowFilesModal(undefined)
    }

    return (
        <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 my-3'>
            {AI_AGENTS?.map((item: any, idx: number) => {
                return (
                    <div key={idx} className='border border-1 border-black dark:border-borderColor-darkMode p-2 rounded-md'>
                        <div className='flex flex-row items-start'>
                            <img src={item?.img} className='rounded-md object-contain w-[40px] mr-2' />
                            <div>
                                <p className='dark:text-primary-darkMode'>{item?.name}</p>
                                <p className='text-primary-light'>{item?.description}</p>
                            </div>
                        </div>
                        <div className='flex justify-center w-full my-2'>
                            <Button
                                label={'Upload on knowledge base'}
                                className='btn-primary-rounded-less dark:bg-black dark:border-0 dark:text-primary-dark'
                                onClickButton={() => onClickFilesAgent(item)}
                            />
                        </div>
                    </div>
                )
            })}

            {showFilesModal?.show &&
                <KnowledgeFilesModal
                    openModal={showFilesModal?.show}
                    activeAgent={showFilesModal?.agent}
                    handleCloseModal={onHideFilesModal}
                />
            }
        </div>
    )
}
export default AiAgents;